module.exports = __webpack_public_path__ + "./images/f4132b8a68892e42f3c80b3a776e8c99.webp";